export const LocalStorageKey = {
	users: 'user',
	token: 'token',
	// Platform specific auth tokens (UAE = `ae`, KSA = `sa`)
	token_ae: 'token_ae',
	token_sa: 'token_sa',
	proInvestorCount: 'proCount',
	notificationCount: 'notifyCount',
	systemSettings: 'systemSettings',
	tokenRefresh: 'token-refreshing',
	registrationData: 'registration_data',
	registrationInfo: 'registrationInfo',
	loadAllCollection: 'loadAllCollection',
	investorsCollections: 'investorsCollections',
	borrowersCollections: 'borrowersCollections',
	notificationType: 'notificationType',
	nafathVerified: 'nafathVerified',
	isEligibilityCompleted: 'isEligibilityCompleted',
	showOTPUpload: 'showOTPUpload',
	userLoggedInFirstTime: "userLoggedInFirstTime",
	userSurveyDate: 'userSurveyDate',
	tokenExpiring: "tokenExpiring",
	isKSApopup: "isKSApopup",
	checkPointServey: "checkPointServey",
	myOrders: "myOrders",
	NafathKey: 'dueToNafath',
	LoginInfo: "login-info",
	firstGainApplied: "firstGainApplied",
	userContactNumber: 'userContactNumber',
	userPersonalInfo: 'userPersonalInfo',
	tempLoginResp: 'tempLoginResp',
	depositPopup: "depositPopup",
	isTermsDone: 'isTermsDone',
	activeLoanId: "activeLoanId"
};
